import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import PageLayout from "./components/PageLayout";
import {
  normalizeCarStages,
  getCurrentStage
} from "./utils/buildStages";

function BuildTimeline() {
  const { username, carId } = useParams();

  const [car, setCar] = useState(null);

  useEffect(() => {
    const loadCar = async () => {
      const docRef = doc(db, "profiles", username.toLowerCase());
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();

        const foundCar = data.garageCars?.find(
          (item) => String(item.id) === String(carId)
        );

        if (foundCar) {
          const normalizedCar = normalizeCarStages(foundCar);
          const currentStage = getCurrentStage(normalizedCar);

          setCar({
            ...normalizedCar,
            images: currentStage.images || [],
            mods: currentStage.mods || [],
            timeline: currentStage.timeline || []
          });
        }
      }
    };

    loadCar();
  }, [username, carId]);

  if (!car) {
    return (
      <PageLayout maxWidth="700px" showBack>
        <div style={loadingStyle}>Loading timeline...</div>
      </PageLayout>
    );
  }

  const modTimelineEntries =
    car.mods
      ?.filter((mod) => mod.installedDate)
      .map((mod) => ({
        id: `mod-${mod.id}`,
        date: mod.installedDate,
        mod: `Installed ${mod.partName}${
          mod.brand ? ` - ${mod.brand}` : ""
        }${
          mod.installedMileage
            ? ` at ${mod.installedMileage} miles`
            : ""
        }`
      })) || [];

  const combinedTimeline = [
    ...(car.timeline || []),
    ...modTimelineEntries
  ].sort((a, b) => new Date(b.date) - new Date(a.date));

  return (
    <PageLayout
      title={`${car.year} ${car.make} ${car.model}`}
      subtitle="Build Timeline"
      maxWidth="700px"
      showBack
    >
      {combinedTimeline.length > 0 ? (
        <div style={timelineContainerStyle}>
          {combinedTimeline.map((entry) => (
            <div key={entry.id} style={timelineEntryStyle}>
              <div style={timelineDotStyle}></div>

              <div style={timelineContentStyle}>
                <p style={timelineDateStyle}>{entry.date}</p>

                <p style={timelineModStyle}>{entry.mod}</p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p>No timeline updates yet.</p>
      )}
    </PageLayout>
  );
}

const loadingStyle = {
  color: "white",
  textAlign: "center",
  padding: "40px"
};

const timelineContainerStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "20px"
};

const timelineEntryStyle = {
  display: "flex",
  gap: "16px",
  alignItems: "flex-start"
};

const timelineDotStyle = {
  width: "14px",
  height: "14px",
  borderRadius: "999px",
  backgroundColor: "#ff0033",
  marginTop: "8px",
  flexShrink: 0
};

const timelineContentStyle = {
  backgroundColor: "#1c1c1c",
  padding: "18px",
  borderRadius: "14px",
  width: "100%"
};

const timelineDateStyle = {
  fontWeight: "bold",
  marginBottom: "8px"
};

const timelineModStyle = {
  opacity: 0.9,
  lineHeight: "1.6",
  whiteSpace: "pre-line"
};

export default BuildTimeline;